<footer class="footer">
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="copy-right text-left">© 2025 Digital Alchemy Agency. All rights reserved</div>
        </div>
        <div class="col-md-6 col-xs-12">
          <ul class="social-media">
            <li *ngFor="let social of socialMedia">
              <a [ngClass]="social.icon" 
                 [href]="social.url" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 [title]="'Visit our ' + social.iconClass + ' page'">
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>